export default __webpack_public_path__ + "static/media/dashbaord_suspend-white.596b62cc.svg";